import { useMemo } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import Stack from '@mui/material/Stack';
import { Icon } from '@/components/atoms/Icon/Icon';
import { Label } from '@/components/atoms/Label/Label';

export interface ShortlistItem {
  id: string;
  title: string;
  subTitle: string;
  isComplete: boolean;
  order: number;
}

interface ShortlistProgressProps {
  className?: string;
  shortlistItems?: ShortlistItem[];
}

export const ShortlistProgress = ({
  shortlistItems,
}: ShortlistProgressProps) => {
  // memos
  const sortedshortlistItems = useMemo(() => {
    const shortlistItemsCopy = shortlistItems?.slice();
    return shortlistItemsCopy?.sort((a, b) => a.order - b.order);
  }, [shortlistItems]);

  return (
    <Stack sx={{ gap: sp[8], position: 'relative' }}>
      <Box
        sx={{
          height: '78%',
          width: '3rem',
          position: 'absolute',
          top: '11%',
          left: sp[16],
          borderLeft: `2px dashed ${'#d9d9d9'}`,
        }}
      />
      {sortedshortlistItems?.map((item: ShortlistItem) => (
        <Stack direction='row' sx={{ gap: sp[12] }} key={item.id}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon
              icon='check'
              fontSize={16}
              fill={item.isComplete ? '#335f43' : '#f2ede3'}
              color={!item.isComplete ? '#ffffff' : undefined}
            />
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              py: sp[16],
              alignContent: 'center',
            }}
          >
            <Box
              sx={{
                typography: 'bodyMediumWeight',
                color: '#404042',
              }}
            >
              <Label id={item.id} text={item.title} />
            </Box>
          </Box>
        </Stack>
      ))}
    </Stack>
  );
};

ShortlistProgress.displayName = 'ShortlistProgress';

export default ShortlistProgress;
